<template>
  <div class="badge badge-pill badge-upgrade badge-primary">
    <IconBolt />
    <router-link class="alert-link" :to="{ name: 'account_plan' }">
      <span>{{targetPlan | upperFirst}}</span>
      <span v-if="!featureIsSupported && header" v-html="header"></span>
    </router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import filters from '@/mixins/filters'

const plans = [
  'free',
  'basic',
  'pro',
  'plus'
]

export default {
  mixins: [ filters ],
  props: {
    targetPlan: String,
    tryForFree: Boolean,
    noFreeUsers: Boolean
  },
  computed: {
    ...mapState([ 'plan' ]),
    andAbove: function () {
      return this.targetPlan !== plans[plans.length - 1]
    },
    freeUser: function () {
      return [ 'affiliate', 'shopify_staff' ].includes(this.plan)
    },
    normalHeader: function () {
      const text = [
        'This feature is'
      ]

      if (!this.andAbove && !this.freeUser) {
        text.push('only')
      }

      text.push(`available in <strong class="font-weight-bold"> ${this.upperFirst(this.targetPlan)} plan${this.andAbove ? ' and above' : ''}.</strong>`)

      if (this.preview && ![ 'affiliate', 'shopify_staff' ].includes(this.plan)) {
        text.push('You can preview this feature for free.')
      }

      return text.join(' ')
    },
    featureIsSupported: function () {
      const currentPlanIndex = plans.indexOf(this.plan)
      const targetPlanIndex = plans.indexOf(this.targetPlan)

      if (currentPlanIndex >= targetPlanIndex) return true

      return false
    },
    header: function () {
      if (this.freeUser && !this.noFreeUsers) return ' &mdash; Try for free'
      if (this.tryForFree) return ' &mdash; Preview for free'

      return false
    },
    subHeader: function () {
      if (this.higherLimit) return this.higherLimitSubHeader + ' '

      return this.normalSubHeader + ' '
    },
    normalSubHeader: function () {
      if (this.preview) {
        if (this.plan === 'affiliate') {
          return 'You can try this feature for free on your development store!'
        } else if (this.plan === 'shopify_staff') {
          return 'As a Shopify employee, you can use this feature for free on your store!'
        }
      }

      return 'Upgrade to use this feature.'
    },
    higherLimitSubHeader: function () {
      return 'Upgrade to add more items.'
    }
  }
}
</script>
